// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumLock-cls1_Ax7","cls2":"PremiumLock-cls2_AjF PremiumLock-cls1_Ax7"};